@if (currentWorkspace) {
  <mat-card class="project-overview-card">
    <div class="card-content">
      <div class="header-section">
        <div class="project-info">
          <h2 class="project-name">{{ currentWorkspace.name }}</h2>
          <p class="project-description">
            {{ currentWorkspace.description }}
          </p>
        </div>

        <div class="project-status-box">
          <button
            mat-button
            *appRequiredRoles="['admin']"
            class="archive-button"
            [disabled]="archiveIsLoading"
            (click)="changeStatus(!currentWorkspace.is_archived)">
            <mat-icon matChipAvatar>{{ currentWorkspace.is_archived ? 'unarchive' : 'archive' }}</mat-icon>
            {{ currentWorkspace.is_archived ? 'Unarchive' : 'Archive' }}
          </button>
        </div>
      </div>

      <div class="metrics-grid">
        <div class="metric-box">
          <div class="metric-icon-wrapper">
            <mat-icon class="metric-icon metric-icon-blue">schedule</mat-icon>
            <div class="metric-details">
              <div class="metric-label">Last Modified</div>
              <time [dateTime]="currentWorkspace.updated_at" class="metric-value">
                {{ currentWorkspace.updated_at | date: 'mediumDate' }}
              </time>
            </div>
          </div>
        </div>

        <div class="metric-box">
          <div class="metric-icon-wrapper">
            <div class="metric-icon rounded-icon" [class]="[currentWorkspace | workspaceStatusClass]"></div>
            <div class="metric-details">
              <div class="metric-label">Workspace status</div>
              <div class="metric-value">
                {{ currentWorkspace | workspaceStatus }}
              </div>
            </div>
          </div>
        </div>

        <div class="metric-box">
          <div class="metric-icon-wrapper">
            <mat-icon class="metric-icon metric-icon-orange">playlist_add_check</mat-icon>
            <div class="metric-details">
              <div class="metric-label">Active Tasks</div>
              <div class="metric-value">
                {{ tasks.length }}
              </div>
            </div>
          </div>
        </div>

        <div class="metric-box">
          <div class="metric-icon-wrapper">
            <mat-icon class="metric-icon metric-icon-deep-blue">description</mat-icon>
            <div class="metric-details">
              <div class="metric-label">Agent run status</div>
              <div class="metric-value">
                {{ documentStatus.status | agentStatus }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
}
